import type { TFunction } from "i18next";
import { RegulationBucket } from "../../autogen/bff-api";

export const regulationLabel = (t: TFunction, bucket: RegulationBucket): string =>
  ({
    [RegulationBucket.FoaPartI]: t("PART_I"),
    [RegulationBucket.FoaPartIi]: t("PART_II"),
    [RegulationBucket.FoaPartIii]: t("PART_III"),
    [RegulationBucket.FoaPartIv]: t("PART_IV"),
    [RegulationBucket.Utilities]: t("FORSYNINGSFORSKRIFTEN"),
    [RegulationBucket.Concessions]: t("KONSESJONSKONTRAKTFORSKRIFTEN"),
    [RegulationBucket.OutsideRegulation]: t("OUTSIDE_FOA"),
    [RegulationBucket.NotStated]: t("Not stated"),
    [RegulationBucket.NotClassified]: t("Not classified"),
    [RegulationBucket.Private]: t("Private procurements"),
  })[bucket];
